import * as React from "react";

import { NetworkCallsContextState } from "./types";

export const NetworkCallsContext = React.createContext<
  NetworkCallsContextState | undefined
>(undefined);

export const useNetworkCalls = () => {
  const context = React.useContext(NetworkCallsContext);
  if (context === undefined) {
    throw new Error(
      "useNetworkCalls must be used within a NetworkCallsProvider"
    );
  }
  return context;
};
